import axiosInstance from './util/auth_util'

const authService = {
  // 登录
  async login(email, password) {
    try {
      const response = await axiosInstance.post(`/login`, {
        email,
        password
      })
      if (response.data.access_token) {
        // 只存储 access token，refresh token 现在由 cookie 处理
        sessionStorage.setItem('access_token', response.data.access_token)
        sessionStorage.setItem('user', JSON.stringify(response.data.user))
      }
      return response.data
    } catch (error) {
      if (error.status == 500) {
        throw "请求失败，请重试"
      }

      // 先确保 error 存在，否则直接返回 "请求超时"
      if (!error || !error.response) {
        throw "请求超时"
      }
  
      // 获取服务器返回的错误信息
      const errorMessage = error.response?.data?.detail || error.msg
  
      // 确保 errorMessage 不是空字符串
      throw errorMessage?.trim() ? errorMessage : "请求超时"
    }
  },

  // 刷新令牌
  async refreshToken() {
    try {
      // 不需要手动发送 refresh token，它会通过 cookie 自动发送
      const response = await axiosInstance.post(`/refresh`)
      if (response.data.access_token) {
        sessionStorage.setItem('access_token', response.data.access_token)
      }
      return response.data
    } catch (error) {
      // 如果刷新失败，清除所有认证信息
      sessionStorage.removeItem('access_token')
      sessionStorage.removeItem('user')
      throw error.response?.data || error.message
    }
  },

  // 更新登录用户
  async update_login_user(){
    try {
      const response = await axiosInstance.patch(`/updatelogin`)
      return response
    } catch (error) {
      throw error.response?.data || error.message
    }
  },

  // 注册
  async register(email = {}) {
    try {
      const response = await axiosInstance.post(`/register`, {
        email
      })
      return response.data
    } catch (error) {
      throw error.response?.data || error.message
    }
  },

  // 忘記密碼验证用户身份
  async verifyUserIdentity(params) {
    try {
      const response = await axiosInstance.post("/verify-forgot-password",params)
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  // 忘记密码
  async forgotPassword(params) {
    try {
      const response = await axiosInstance.post(`/reset-password`, params)
      return response.data
    } catch (error) {
      throw error.response?.data || error?.message
    }
  },

  // 重置密码
  async resetPassword(email, code , new_password) {
    try {
      const response = await axiosInstance.post(`/reset-password`, {
        email,
        code,
        new_password
      })
      return response.data
    } catch (error) {
      console.error("身份验证失败", error)
      throw error
    }
  },

  // 验证用户
  async Authenticate_users(token) {
    try {
      const response = await fetch(`/api/auth/ausers`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      })
  
      if (!response.ok) {
        throw new Error(`身份验证失败: ${response.statusText}`)
      }
  
      return await response.json()
    } catch (error) {
      console.error("身份验证失败", error)
      return null
    }
  },

  // 获取用户角色
  async getuserRole(){
    try {
      const response = await axiosInstance.get(`/role_management/role`)
      return response.data
    } catch (error) {
      throw error.response?.data || error.message
    }
  },
  
  // 退出登录
  async logout() {
    try {
      const response = await axiosInstance.patch(`/logout`)
      sessionStorage.removeItem('access_token')
      sessionStorage.removeItem('user')
      // 后端需要设置清除 refresh token cookie
      return response
    } catch (error) {
      throw error.response?.data || error.message
    }
  },

  // 获取当前用户信息
  getCurrentUser: async () => {
      try {
          const response = await axiosInstance.get('/current-user')
          return response.data
      } catch (error) {
          throw error.response?.data || error.message
      }
  },

  // 判断是否已认证
  isAuthenticated() {
    return !!sessionStorage.getItem('access_token')
  },

  // 谷歌登录
  async googleLogin(token) {
    try {
      const response = await axiosInstance.post('/google-login',{
        token: token
      })
      if (response.data.success) {
        // 存储token等登录信息
        localStorage.setItem('token', response.data.token)
        return {
          success: true,
          data: response.data
        }
      }
      return {
        success: false,
        error: '登录失败'
      }
    } catch (error) {
      throw new Error(error.response?.data?.message || '谷歌登录失败')
    }
  },

}

export default authService